module.exports = __webpack_public_path__ + "img/suit-07.ce033e38.png";